import { useState } from 'react';

var useSort = function useSort(initialData) {
  var _useState = useState(initialData),
      sortedData = _useState[0],
      setSortedData = _useState[1];

  var _useState2 = useState({
    field: null,
    sortDirection: null
  }),
      sortConfig = _useState2[0],
      setSortConfig = _useState2[1];

  function onRequestSort(field, sortDirection, customSort) {
    var sortableData = [].concat(sortedData);

    if (field && sortDirection) {
      // sets incoming clicked field and sort direction
      setSortConfig({
        field: field,
        sortDirection: sortDirection
      }); // use customSort when it's provided

      if (customSort) {
        if (sortDirection === 'ascending') {
          sortableData.sort(customSort);
          setSortedData(sortableData);
          return;
        }

        sortableData.sort(customSort).reverse();
        setSortedData(sortableData);
        return;
      } // use default sorting method when there's no customSort provided


      sortableData.sort(function (a, b) {
        // skip empty field values
        if (!a[field] || !b[field]) {
          return 0;
        } // it's possible to have value key on data


        var aValue = a[field].value || a[field];
        var bValue = b[field].value || b[field];

        if (aValue < bValue) {
          return sortDirection === 'ascending' ? -1 : 1;
        }

        if (aValue > bValue) {
          return sortDirection === 'ascending' ? 1 : -1;
        }

        return 0;
      });
      setSortedData(sortableData);
    }
  }

  return [sortedData, onRequestSort, sortConfig];
};

export default useSort;